import React from "react";
import { useSelector } from "react-redux";
import { DonationInput } from "@qgiv/core-donor";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";

const ConnectedDonationInput = () => {
    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );

    return <DonationInput currency={currency} />;
};

export default ConnectedDonationInput;
